import EventEmitter from "eventemitter3";

export default class Mediator {
	private static emitter: EventEmitter = new EventEmitter();

	public static emit(event: string, ...args): void {
		Mediator.emitter.emit(event, ...args);
	}

	public static on(event: string, callback: (...args: any[]) => void): void {
		Mediator.emitter.on(event, callback);
	}

	public static off(event: string, callback?: (...args: any[]) => void): void {
		if (callback) {
			Mediator.emitter.off(event, callback);
		} else {
			Mediator.emitter.removeAllListeners(event);
		}
	}
}
